import { PageLoading } from "../components/ui/PageState";
import * as React from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { supabase } from "../lib/supabase";

/**
 * Supabase OAuth 리다이렉트 처리.
 * Supabase Dashboard → Authentication → URL Configuration 에서
 * Redirect URLs에 이 경로를 추가해야 함 (예: https://yourdomain.com/login/supabase-callback).
 */
export function SupabaseAuthCallback() {
  const navigate = useNavigate();
  const { loginWithSupabase } = useAuth();
  const [error, setError] = React.useState<string | null>(null);

  React.useEffect(() => {
    if (!supabase) {
      navigate("/login?error=supabase_not_configured");
      return;
    }

    const client = supabase;

    const run = async () => {
      // OAuth 리다이렉트 직후 URL 해시에서 토큰을 파싱해 세션에 반영할 시간을 줌
      await new Promise((r) => setTimeout(r, 100));
      const { data: { session }, error: sessionError } = await client.auth.getSession();
      if (sessionError) {
        setError(sessionError.message);
        return;
      }
      if (!session?.access_token) {
        navigate("/login?error=no_supabase_session");
        return;
      }
      try {
        await loginWithSupabase(session.access_token);
        const next = new URLSearchParams(window.location.search).get("next") || "/";
        navigate(next);
      } catch (e: any) {
        setError(e?.message || "로그인에 실패했습니다.");
      }
    };

    run();
  }, [navigate, loginWithSupabase]);

  if (error) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-center">
          <p role="alert" className="text-red-600 mb-4">{error}</p>
          <button
            type="button"
            className="fe-primary-action rounded-xl px-4 py-3 text-sm font-semibold"
            onClick={() => navigate("/login")}
          >
            로그인으로 돌아가기
          </button>
        </div>
      </div>
    );
  }

  return <PageLoading message="로그인을 마무리하고 있어요" />;
}
